import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'docket-number-account-reference-cell',
  template: ` <ng-container *ngIf="!id; else link">N/a</ng-container>
    <ng-template #link>
      @if (url.length) {
        <a
          matTooltip="View Contract"
          matTooltip-position="left"
          tooltipHideDelay="0"
          [routerLink]="url"
        >
          {{ id }}
          @if (accountsReference) {
            ({{ accountsReference }})
          }
        </a>
      } @else {
        {{ id }}
        @if (accountsReference) {
          ({{ accountsReference }})
        }
      }
    </ng-template>`,
  standalone: true,
  imports: [NgIf, MatTooltip, RouterLink]
})
export class DocketNumberAccountReferenceCellComponent
  implements AgRendererComponent
{
  id;
  accountsReference;
  url = [];

  agInit(params: any): void {
    if (params.value) {
      this.id = params.value.id;
      this.accountsReference = params.value.account_reference;
      this.url = ['/docket', this.id];
    }
  }

  refresh(params: any): boolean {
    this.id = params.value.id;
    this.accountsReference = params.value.account_reference;
    this.url = ['/docket', this.id];
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
